import { ICollection } from '../../../app/models/Collection'
import { FileType } from '../../../app/models/FileType';

interface IProps {
	collection?: ICollection
}

const CollectionPodComponent: React.FC<IProps> = ({ collection }) => {

	// this method to request a pod from parcel perfect.. to be implemented
	// const requestPod = () => {
	// 	getPod(collection?.id!)
	// 		.then(result => {
	// 			setPod({title: 'POD', link: result.url, id: result.url, publicId: result.url})
	// 		});
	// }

	// because of a legacy implementation where the title was used to determine if a file was a pod, we 
	// also need this filter for backwards compatibility. ToDo: either update the type in the db where title
	// is "POD" or just delete this condition after 2026
	const content = collection?.attachments.map(pod => (pod.type === FileType.Pod || pod.title === "POD") &&
		<a target='_blank' rel='noreferrer' href={pod.link}>Download POD</a>
	)

	return (
		<>
			{content && content.length > 0 &&
				<div style={{ marginBottom: '16px' }}>
					{content}
				</div>
			}
		</>
	)
}

export default CollectionPodComponent
